import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { romaneioService } from '../../../../api';
import type { BloqueiosListParams } from '../../../../api/services/romaneioService';
import { useOps } from '../../../../hooks/useOps';

export const bloqueiosQueryKeys = {
  all: ['bloqueios'] as const,
  list: (ops: string, page: number, filters: BloqueiosListParams['filters']) =>
    [...bloqueiosQueryKeys.all, 'list', ops, page, filters] as const,
};

export const mensagemErro = (error: any): string =>
  error?.response?.data?.message || error?.message || 'Erro inesperado.';

const PAGE_SIZE = 20;

export function useBloqueios(
  page: number,
  filters: BloqueiosListParams['filters']
) {
  const { currentOps, getCurrentOpsConfig } = useOps();
  const dbName = getCurrentOpsConfig()?.dbName;

  return useQuery({
    queryKey: bloqueiosQueryKeys.list(currentOps || '', page, filters),
    queryFn: async () => {
      const response = await romaneioService.listarBloqueios({
        dbName: dbName!,
        ops: String(currentOps),
        page,
        limit: PAGE_SIZE,
        filters,
      });
      return response.data;
    },
    enabled: !!currentOps && !!dbName,
    placeholderData: keepPreviousData,
  });
}

export function useBloquearEntregadores() {
  const { currentOps, getCurrentOpsConfig } = useOps();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: {
      documentos: string[];
      acao: 'bloquear' | 'desbloquear';
      motivo_codigo?: string;
      motivo_texto?: string;
    }) => {
      const dbName = getCurrentOpsConfig()?.dbName;
      if (!dbName || !currentOps)
        throw new Error('Configuração da operação não encontrada');
      const response = await romaneioService.bloquearEntregadores({
        ...params,
        dbName,
        ops: currentOps,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bloqueiosQueryKeys.all });
    },
  });
}
